import { getPartnerDetails } from '../utils/helper'
// import { getUserSecret } from './secrets'

export const getConfigDetails = () => {

  //Get the partner
  // const user = window.location.toString().split('/')[3]

  // switch ('demo') {
  // switch ('preStage') {
  // switch ('staging') { 
    // switch ('preprod') {
    switch ('live') {
    case 'demo': //staging2
      return {
        baseURL: 'https://demo-api.parkengage.com/',
        adminUrl: 'https://demo-admin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        checkInUrl: 'https://demo-checkin.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com',
        // portalURL: 'http://localhost:3000/navigating',
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '9f3Blizhmt8qhkw62Y16qTJXa',
      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        adminUrl: 'https://pre-stage-admin.parkengage.com',
        checkInUrl: 'https://pre-stage-checkin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'KTlRNfQyLFXRIALiJP6IL9pFo',
      }
    case 'staging': //staging
      return {
        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        checkInUrl: 'https://staging-checkin.breezeparking.com',
        transientURL: 'https://staging-pci.breezeparking.com',
        portalURL: 'https://staging-customerportal.breezeparking.com',
        FACILITY_ID: getPartnerDetails()?.facilities?.[0]?.id ? getPartnerDetails()?.facilities?.[0]?.id : null, // Uncommented due to Intrapark Business Events tab not showing results
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'KTlRNfQyLFXRIALiJP6IL9pFo',
      }
    case 'preprod': //staging
      return {
        baseURL: 'https://preprod-api.parkengage.com/',
        adminUrl: 'https://preprod-admin.parkengage.com',
        checkInUrl: 'https://preprod-checkin.parkengage.com',
        transientURL: 'https://preprod-transient.parkengage.com',
        portalURL: 'https://preprod-customerportal.parkengage.com',
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'V8O5ISYRk19Ta77MDasNKgjeZ',
      }
    case 'live': //live
      return {
        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://adminportal.breezeparking.com',
        checkInUrl: 'https://checkin.breezeparking.com',
        transientURL: 'https://pci.breezeparking.com',
        portalURL: 'https://customerportal.breezeparking.com',
        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id,
        CLIENT_ID: getPartnerDetails()?.clients?.id,
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : 'V8O5ISYRk19Ta77MDasNKgjeZ',
      }
  }
}
